<template>
  <div class="location-form-wrapper card">
    <page-header
      title="Add New Terminal"
      breadcrumbText="Dashboard >> Settings >> Account Owner >> New Terminal"
    />
    <div class="new-location-form">
      <div class="container-fluid">
        <div class="row">
          <div class="pl-0 col-md-4 col-lg-4 col-12">
            <div class="picture-upload-form text-center">
              <div class="picture-upload-form__header">
                <p class="text-secondary-orange font-semibold">
                  Upload Picture
                </p>
              </div>
              <div class="my-3">
                <image-upload
                  @input="handleImageUpload($event)"
                  @remove-image="removeImage"
                  :isUploadingImage="isUploadingImage"
                />
              </div>
            </div>
          </div>
          <div class="col-md-8 col-lg-8 col-12">
            <div class="new-location-form__col-two__header">
              <p class="text-secondary-orange font-semibold mb-3">
                Terminal Details
              </p>
            </div>
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-12 col-lg-6 col-12">
                  <div class="new-location-form__single-input-wrapper">
                    <label class="label">Location Name</label>
                    <input
                      type="text"
                      class="input"
                      v-model="newLocation.locationName"
                    />
                  </div>
                </div>
                <div class="col-md-12 col-lg-6 col-12">
                  <div class="new-location-form__single-input-wrapper">
                    <label class="label">Address</label>
                    <input
                      type="text"
                      class="input"
                      v-model="newLocation.address"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 col-lg-6 col-12">
                  <div class="new-location-form__single-input-wrapper">
                    <label class="label">Location Type</label>
                    <input
                      type="text"
                      class="input"
                      v-model="newLocation.type"
                    />
                  </div>
                </div>
                <div class="col-md-12 col-lg-6 col-12">
                  <div class="new-location-form__single-input-wrapper">
                    <label class="label">Country</label>
                    <el-select
                      filterable
                      v-model="newLocation.country"
                      placeholder="Select"
                    >
                      <el-option
                        v-for="country in countries"
                        :key="country"
                        :label="country"
                        :value="country"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 col-lg-6 col-12">
                  <div class="new-location-form__single-input-wrapper">
                    <label class="label">State</label>
                    <el-select
                      filterable
                      v-model="newLocation.state"
                      placeholder="Select"
                    >
                      <el-option
                        v-for="state in states"
                        :key="state.id"
                        :label="state.name"
                        :value="state.stateId"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="col-md-12 col-lg-6 col-12">
                  <div class="new-location-form__single-input-wrapper">
                    <label class="label">City</label>
                    <input
                      type="text"
                      class="input"
                      v-model="newLocation.city"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 col-lg-6 col-12">
                  <div class="new-location-form__single-input-wrapper">
                    <label class="label">ZIP Code</label>
                    <input
                      type="text"
                      class="input"
                      v-model="newLocation.zipCode"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="button-wrapper">
      <button
        class="button button-secondary button-long"
        @click="$router.push({ name: 'LocationAndTax' })"
      >
        Cancel
      </button>
      <button
        class="button button-primary button-long"
        :disabled="disableButton"
        @click="createLocation"
      >
        <button-loader v-if="creatingLocation" />
        <span v-else>Save</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newLocation: {
        locationName: "",
        type: "",
        address: "",
        country: "",
        state: "",
        city: "",
        zipCode: "",
        imageurl: "",
      },
      creatingLocation: false,
      states: [],
      countries: ["Nigeria"],
      isUploadingImage: false,
    };
  },
  computed: {
    disableButton() {
      return this.shouldDisableButton(this.newLocation);
    },
  },
  mounted() {
    this.getAllStates();
  },
  methods: {
    async createLocation() {
      this.creatingLocation = true;
      try {
        let response = await this.$_createLocation(this.newLocation);
        console.log(response);
        this.creatingLocation = false;
        this.generateToast("Location successfully created!", "success");
        this.$router.push({ name: "LocationAndTax" });
      } catch (error) {
        this.creatingLocation = false;
        this.handleError(error);
      }
    },
    
    async getAllStates() {
      try {
        let response = await this.$_getAllStates();
        console.log(response);
        this.states = response.data.findState;
      } catch (error) {
        this.handleError(error);
      }
    },
    resetInputFields() {
      this.newLocation = {
        locationName: "",
        type: "",
        address: "",
        country: "",
        state: "",
        city: "",
        zipCode: "",
      };
    },
    async handleImageUpload(image) {
      this.isUploadingImage = true;
      try {
        let response = await this.uploadImage(image);
        this.newLocation.imageurl = response;
        // console.log("imageurl", response);
        this.isUploadingImage = false;
      } catch (error) {
        this.handleError(error);
        this.isUploadingImage = false;
      }
    },
    removeImage() {
      this.newLocation.imageurl = null;
    },
  },
};
</script>

<style scoped>
.new-location-form {
  margin: 2rem 0 1rem;
}
.picture-upload-form {
  border: 1px solid #edf2ef;
  border-radius: 10px;
  padding: 1rem 1rem;
}
.picture-upload-form__img-wrapper {
  position: relative;
}
.location-img {
  width: 10rem;
  margin: 1rem auto;
}
.upload-img-icon {
  position: absolute;
  right: 3.5rem;
  bottom: 1rem;
}
.picture-upload-form__meta {
  padding-top: 1rem;
}
.new-location-form__single-input-wrapper {
  margin-bottom: 1.25rem;
}
.label {
  font-size: 0.9rem;
}
.input-field {
  display: block;
  width: 100%;
  height: 2.75rem;
  margin-bottom: 0.5rem;
  background: #fafafd;
  border: 0.5px solid #c5d1e6;
  box-sizing: border-box;
  border-radius: 4px;
}
.new-location-form__col-three {
  padding-top: 2.45rem;
}
</style>
